import { render, staticRenderFns } from "./partnerFooter.vue?vue&type=template&id=226a75b6&"
import script from "./partnerFooter.vue?vue&type=script&lang=js&"
export * from "./partnerFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports